import axios, { porticoApi } from 'utils/axios'
import { REACT_APP_ORG, ENVIRONMENT } from 'utils/env'

export const fetchReportUrl = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return axios.get(`/dashboards/${ENVIRONMENT}/${REACT_APP_ORG}/venues?timezone=${timezone}`)
}

export const downloadReport = period =>
  axios.get(`/download/${ENVIRONMENT}/${REACT_APP_ORG}/${period}`)

export const fetchVenues = () => porticoApi.get(`/devices/venues`)

export default {
  fetchReportUrl,
  downloadReport,
  fetchVenues
}
